import { render, staticRenderFns } from "./TeacherEvaluationsCell.vue?vue&type=template&id=0f52c16b&scoped=true"
import script from "./TeacherEvaluationsCell.vue?vue&type=script&lang=js"
export * from "./TeacherEvaluationsCell.vue?vue&type=script&lang=js"
import style0 from "./TeacherEvaluationsCell.vue?vue&type=style&index=0&id=0f52c16b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f52c16b",
  null
  
)

export default component.exports